import { useEffect } from "react";
import { useParams } from "react-router-dom";
import * as WolframNotebookEmbedder from "wolfram-notebook-embedder";
import Navbar from "../../components/common/NavBar";
import { ErrorBoundary } from "react-error-boundary";
import Footer from "../../components/common/Footer";
import ErrorFallback from "../../components/error/ErrorHandler";

export default function SpreadsheetResources() {
  let params = useParams();

  useEffect(() => {
    // debugger;
    embedNotebook();
  }, [params.type]);

  function embedNotebook() {
    const url = getRequiredResource();
    WolframNotebookEmbedder.embed(
      url,
      document.getElementById(
        `notebook${
          params.type === "glossary"
            ? "1"
            : params.type === "blockchain-archive"
            ? "2"
            : "3"
        }`
      )
    );
  }

  function getRequiredResource() {
    switch (params.type) {
      case "glossary":
        return window.glossary_URL;
      case "blockchain-archive":
        return window.blockChain_archive_URL;
      case "contact-list":
        return window.contact_list_URL;
      default:
        break;
    }
  }

  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
        <Navbar />
        {params.type === "glossary" && (
          <div id="notebook1" style={{ minHeight: "75vh" }}></div>
        )}

        {params.type === "blockchain-archive" && (
          <div id="notebook2" style={{ minHeight: "75vh" }}></div>
        )}

        {params.type === "contact-list" && (
          <div id="notebook3" style={{ minHeight: "75vh" }}></div>
        )}

        {/* <>{embedNotebook()}</> */}
        <Footer />
      </ErrorBoundary>
    </>
  );
}
